import { Fragment, PropsWithChildren, Ref, useEffect, useRef } from "react"
import clsx from "clsx"
import styles from './filters.module.css'

export const Filters = ({ children, className, ref, ...props}: { className?: string, ref?: Ref<HTMLDivElement> } & PropsWithChildren) => {
  const innerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (innerRef.current) {
      const offset = innerRef.current.getBoundingClientRect().bottom
      document.documentElement.style.setProperty("--calculated-offset-filters", offset.toString());
    }
  }, [])

  return (
    <>
      {/* Non-sticky anchor sitting at the same document position as .wrapper, used as a reliable scroll target (position: sticky freezes getBoundingClientRect once stuck) */}
      <div ref={ref}/>
      <div ref={innerRef} className={clsx(styles.wrapper, className)} {...props}>
        {children}
      </div>
    </>
  )
}